import React, { useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";
import {
  ISuccessionPlanColumnDetails,
  ITableColumnState,
} from "../../../../../types/types";
import {
  sortTableData,
  findKeysInArray,
  isOwner,
} from "../../../../../utils/common";

import DocumentTable from "../../../../common/DocumentTable/DocumentTable";

interface ITableProp {
  documentTypeList: DropdownItem[] | undefined;
  data: any;
  isError: boolean;
  deleteDocument: (docName: string, id: string | number) => {};
  onClickEditIcon?: (document: any) => void;
  type?: string;
}

const Table: React.FC<ITableProp> = ({
  documentTypeList,
  data,
  isError,
  deleteDocument,
  onClickEditIcon,
  type,
}) => {
  const [successionPlanList, setsuccessionPlanList] = useState<
    ISuccessionPlanColumnDetails[] | []
  >([]);
  const [columnState, setColumnState] = useState<
    ITableColumnState<ISuccessionPlanColumnDetails>[]
  >([]);

  const defaultColumnName =
    columnState[0]?.sortOrder === "nosort" || isEmpty(columnState)
      ? "updatedDate"
      : columnState[0]?.column;
  const defaultSort =
    columnState[0]?.sortOrder === "nosort" || isEmpty(columnState)
      ? "desc"
      : columnState[0]?.sortOrder;
  // const [
  //   updateSuccessionPlanDocsList,
  //   { isLoading: isLoadingDeleteSuccessioPlan },
  // ] = useDeleteSuccessionPlanDocsItemMutation();

  // Pass exact key names from response to table data
  const tableColumnData = [
    "aboSuccessionId",
    "name",
    "documentType",
    "size",
    "updatedDate",
    "note",
  ];

  useEffect(() => {
    let prepareTableData = findKeysInArray(data?.body ?? [], tableColumnData);
    const codeToValueMap = new Map(
      documentTypeList?.map((doccode) => [doccode.code, doccode.value])
    );
    // Add documentvalue to table data
    prepareTableData?.forEach((docRow) => {
      if (codeToValueMap.has(docRow?.documentType?.toString())) {
        docRow["docTypeName"] = codeToValueMap?.get(
          docRow?.documentType?.toString()
        );
        docRow["commonIdKey"] = docRow.aboSuccessionId;
      }
      const original = (data?.body ?? []).find(
        (item: any) => item?.aboSuccessionId === docRow?.aboSuccessionId
      );
      docRow["isOwner"] = isOwner(original?.audit?.createdBy);
    });
    const intialSortData = sortTableData(
      prepareTableData,
      defaultColumnName,
      defaultSort
    );

    setsuccessionPlanList(intialSortData);
  }, [data, documentTypeList]);

  return (
    <DocumentTable
      tableData={successionPlanList}
      isLoading={false}
      columnState={columnState}
      setColumnState={setColumnState}
      deleteDocument={deleteDocument}
      columnsToBeVisible={["docName", "docType", "date", "actions"]}
      downloadDocUrlParam={"succession"}
      isFourColumn={true}
      onClickEditIcon={onClickEditIcon}
      screenName={"successionplan"}
      rowLimit={type === "growthPlan" ? 5 : undefined}
      type={type}
    />
  );
};

export default Table;
